import React, { useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { changeUserNewPassword } from "../services/ApiServices";

const validate = (values) => {
  const errors = {};
  if (!values.oldPassword) {
    errors.oldPassword = "Please enter your old password.";
  } else if (!values.oldPassword.trim()) {
    errors.oldPassword = `The old password cannot be blank.`;
  } else if (!values.newPassword) {
    errors.newPassword = "Please enter your new password.";
  } else if (values.newPassword.length < 6) {
    errors.newPassword = "New password must be at least 6 characters.";
  } else if (!values.newPassword.trim()) {
    errors.newPassword = `The new password cannot be blank.`;
  } else if (!values.confirmPassword) {
    errors.confirmPassword = "Please confirm your new password.";
  } else if (values.confirmPassword !== values.newPassword) {
    errors.confirmPassword = "Passwords must match.";
  } else if (!values.confirmPassword.trim()) {
    errors.confirmPassword = `The confirm password cannot be blank.`;
  }
  return errors;
};

export const ChangePassword = () => {
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const userEmailId = JSON.parse(window.localStorage.getItem("users"));
  const formik = useFormik({
    initialValues: { oldPassword: "", newPassword: "", confirmPassword: "" },
    validate,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if(userEmailId.emaiId !== null || userEmailId.emaiId !== undefined) {
            const payload = {
                emailId: userEmailId.emailId,
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            }
        const changePasswordByEmailId = await changeUserNewPassword(payload)
        if(changePasswordByEmailId.status === 200) {
          values.oldPassword = ""
          values.newPassword = ""
          values.confirmPassword = ""
         return toast.success(changePasswordByEmailId.data.message)
        
        }
        } else {
            const payload = {
                emailId: userEmailId.mobileNumber,
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            }
        const changePasswordMobileNumber = await changeUserNewPassword(payload)
        if(changePasswordMobileNumber.status === 200) {
          return toast.success(changePasswordMobileNumber.data.message)
         }
        }
      } catch (error) {
        console.error("Login error:", error);
        toast.error(error.response.data.message);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <React.Fragment>
      <div className="aside-heading">
        <h3>Change Password</h3>
      </div>
      <div className="change-password-body">
        <div className="change-password">
          <form onSubmit={formik.handleSubmit}>
            <div className="form-group">
              <label htmlFor="oldPassword">Current Password</label>
              <div className="hideShow-input">
                <div className="password-input">
                  <input
                    type={showOldPassword ? "text" : "password"}
                    id="oldPassword"
                    name="oldPassword"
                    value={formik.values.oldPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div
                  className="show-hide-password"
                  onClick={() => setShowOldPassword(!showOldPassword)}
                >
                  {showOldPassword ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </div>
              </div>
              {formik.touched.oldPassword && formik.errors.oldPassword ? (
                <p className="error-message">{formik.errors.oldPassword}</p>
              ) : null}
            </div>
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <div className="hideShow-input">
                <div className="password-input">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    id="newPassword"
                    name="newPassword"
                    value={formik.values.newPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div
                  className="show-hide-password"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? (
                   <FontAwesomeIcon icon={faEye} /> 
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </div>
              </div>
              {formik.touched.newPassword && formik.errors.newPassword ? (
                <p className="error-message">{formik.errors.newPassword}</p>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <div className="hideShow-input">
                <div className="password-input">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div
                  className="show-hide-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </div>
              </div>
              {formik.touched.confirmPassword &&
              formik.errors.confirmPassword ? (
                <p className="error-message">{formik.errors.confirmPassword}</p>
              ) : null}
            </div>
            <button type="submit">Change Password</button>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};
